/**
 * 图像处理器常量定义
 */

export const ERROR_MESSAGES = {
  EMPTY_ORIGINAL_IMAGE: '原始图像不能为空',
  PROCESSING_ERROR_PREFIX: '处理图像时出错: ',
  UNKNOWN_ERROR: '未知错误'
} as const